<template>
  <section class="footer_99">
    <div class="other_info">
      <div class="info_item">
        <h6>友情链接</h6>
        <ul>
          <li>
            <a href="https://www.meizu.com/" target="_blank" title="魅族商城"
              >魅族商城</a
            >
          </li>
          <li>
            <a href="https://cloud.flyme.cn/" target="_blank" title="云服务"
              >云服务</a
            >
          </li>
          <li>
            <a href="https://www.flyme.com/" target="_blank" title="Flyme官网"
              >Flyme官网</a
            >
          </li>
          <li>
            <a href="https://www.meizu.cn/" target="_blank" title="魅族社区"
              >魅族社区</a
            >
          </li>
        </ul>
      </div>

      <div class="info_item">
        <h6>商务邮箱</h6>
        <ul>
          <li>auto-bd@xjmz.com</li>
        </ul>

        <h6 style="margin-top: 0.28rem">在线时间</h6>
        <ul>
          <li>周一至周五 9:00 - 18:30</li>
        </ul>
      </div>
    </div>

    <div class="divider_line"></div>

    <div class="explain">
      <div class="content_font">
        ©2023 ZHUHAI XINGJI MEIZU INFORMATION TECHNOLOGY CO.,LTD. All rights
        reserved.
      </div>

      <div class="content_item">
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          class="remark_link"
          target="_blank"
          title="工业和信息化部政务服务平"
          >备案号：鄂ICP备2022014710号-9</a
        >

        <div class="remark_no">
          <a
            href="https://www3.res.meizu.com/static/cn/_partial/footer/images/com_licence_b00fe42.jpg"
            title="营业执照"
            target="_blank"
            >营业执照</a
          >
          <span class="middle_line"></span>
          <a href="./use_agreement.html" target="_blank">法律声明</a>
          <span class="middle_line"></span>
          <a href="./knowledge_agreement.html" target="_blank">知识产权声明</a>
        </div>

        <a
          href="https://www-res.flyme.cn/resources/flymeos/v4/assets/common/icp-mz.jpg"
          class="new_line"
          target="_blank"
          title="经营许可证编号"
          >经营许可证编号：合字B2-20170010</a
        >
        <a
          title="广东省互联网违法和不良信息举报中心"
          href="https://www.gdjubao.cn/jb/?harm_type=18"
          class="new_line"
          target="_blank"
          >涉未成年人网络有害信息举报 电话：12377</a
        >
        <a
          href="https://www.gdjubao.cn/jb/Acceptance/swlblyhxx/"
          class="new_line"
          target="_blank"
          title="涉网络暴力有害信息举报专区"
          >涉网络暴力有害信息举报专区</a
        >

        <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496600"
          class="new_line gov"
          target="_blank"
          title="公安机关互联网站安全管理服务平台"
        >
          <span class="font_img" bg-url="/ghs.png" v-bg></span
          >粤公网安备44049102496971号
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { createSection } from '@/utils'

export default {
  name: 'Footer',
}
</script>

<style lang="less" scoped>
.footer_99 {
  height: 9.08rem;
  padding: 0.92rem 0.48rem;
  background-color: #f7f8fa;
  box-sizing: border-box;

  a {
    font-weight: 400;
    font-size: 0.13rem;
    line-height: 0.18rem;
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    display: inline-block;
    text-align: center;

    &:hover {
      text-decoration-line: underline;
      color: #000000;
    }
  }
}

.other_info {
  height: 3.37rem;
  display: flex;

  .info_item {
    display: inline-block;
    width: 3.27rem;
    height: 100%;

    h6 {
      font-weight: 700;
      font-size: 0.32rem;
      line-height: 0.45rem;
      color: #000;
      margin: 0;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      margin: 0.28rem 0 0 0;
      font-weight: 400;
      font-size: 0.28rem;
      line-height: 0.39rem;
      color: rgba(0, 0, 0, 0.5);
    }

    a {
      font-weight: 400;
      font-size: 0.28rem;
      line-height: 0.39rem;
      color: rgba(0, 0, 0, 0.5);
      text-decoration: none;
      display: inline-block;
    }
  }
}

.divider_line {
  width: 100%;
  height: 0.01rem;
  margin: auto;
  background-color: rgba(189, 189, 189, 0.2);
}
.explain {
  display: flex;
  flex-direction: column;

  padding-top: 0.48rem;
  font-weight: 400;
  font-size: 0.22rem;
  line-height: 0.31rem;
  color: rgba(0, 0, 0, 0.5);

  overflow: hidden;

  a {
    font-weight: 400;
    font-size: 0.22rem;
    line-height: 0.31rem;
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    display: inline-block;
    text-align: left;
  }

  .content_font {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 0.27rem 0.12rem 0;
  }

  .remark_no {
    margin-top: 0.12rem;
    display: flex;
    align-items: center;
  }
  .remark_link {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .new_line {
    margin-top: 0.12rem;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.gov {
      display: flex;
      align-items: center;
    }
  }

  .middle_line {
    display: inline-block;
    width: 0.01rem;
    height: 0.14rem;
    background: #bdbdbd;
    opacity: 0.2;
    margin: 0 0.1rem;
  }

  .content_item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .font_img {
    display: inline-block;
    width: 0.15rem;
    height: 0.16rem;
    line-height: 0.16rem;
    background-size: 100%;
    margin-right: 10px;
    vertical-align: text-top;
  }
}
</style>
